// Update to remove jquery?
$(document).ready(function(){
	$('.dropdown')
	.on('show.bs.dropdown', function() {
		$(this).find('.dropdown-menu').first().stop(true, true).slideDown(300);
	})
	.on('hide.bs.dropdown', function() {
		$(this).find('.dropdown-menu').first().stop(true, false).slideUp(300, function() {
		$(this).parent().removeClass('open');
		});
	})
	.on('hidden.bs.dropdown', function() {
		$(this).addClass('open');
	});
});